module.exports = __webpack_public_path__ + "img/ng-cdflogo.6339f703.jpg";